<template>
  <footer class="app-footer">
    <span>
      <a href="https://github.com/dansharisan/anitracks">
        AniTracks
      </a> &copy; 2019 Sten Le
    </span>
    <span class="ml-auto">
      Powered by <a href="http://coreui.io">
        CoreUI
      </a>
    </span>
  </footer>
</template>
<script>
export default { name: 'CFooter' }
</script>
